
// const environment = {
//   'apiUrl':'http://192.168.1.158:21040/api/',
//   'centralUrl':'http://192.168.1.158:21040/api/',
//   'socketIoUrl' : "http://192.168.1.158:21040",
//   'preUser' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJWYWxpZGF0ZWQiOiJPSyIsIlVzZXJJRCI6IjMyODZlYWUzLWM2ZTMtNGZjZS1iNjFlLTUwYTBhODk1OGYyOSIsIlVzZXJOYW1lIjoicHJldXNlciIsIlVzZXJFbWFpbCI6InByZXVzZXJAc21hcnRhcHBsaWNhdGlvbnMuY29tIiwiVXNlclJvbGUiOiJQcmVVc2VyIiwiSXNFbWFpbFZlcmlmaWVkIjoiMCIsImlhdCI6MTc4ODc5MDA0MywiZXhwIjoxODIwMzI2MDQzfQ.jV-hycwewW61Gtzqzleh72wmMiOUjQX3ghcY2evLtNw',
//   'timeoutValue': 20000
// }

const environment = {
  'centralUrl': 'https://starfish-app-gv2l6.ondigitalocean.app/api/', 
  'apiUrl': 'https://starfish-app-gv2l6.ondigitalocean.app/api/', 
  'socketIoUrl' : 'https://starfish-app-gv2l6.ondigitalocean.app',
  'preUser' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJWYWxpZGF0ZWQiOiJPSyIsIlVzZXJJRCI6IjMyODZlYWUzLWM2ZTMtNGZjZS1iNjFlLTUwYTBhODk1OGYyOSIsIlVzZXJOYW1lIjoicHJldXNlciIsIlVzZXJFbWFpbCI6InByZXVzZXJAc21hcnRhcHBsaWNhdGlvbnMuY29tIiwiVXNlclJvbGUiOiJQcmVVc2VyIiwiSXNFbWFpbFZlcmlmaWVkIjoiMCIsImlhdCI6MTc4ODk3NjM4NCwiZXhwIjoxODIwNTEyMzg0fQ.oICSD1lVx3l82A7r7FNhktRo1spL6BDyNB9UE_NZyRU',
 'timeoutValue': 20000
}


// const environment = {
//   'apiUrl':'http://localhost:21040/api/',
//   'socketIoUrl' : "http://localhost:21040",
//   'preUser' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJWYWxpZGF0ZWQiOiJPSyIsIlVzZXJJRCI6IjMyODZlYWUzLWM2ZTMtNGZjZS1iNjFlLTUwYTBhODk1OGYyOSIsIlVzZXJOYW1lIjoicHJldXNlciIsIlVzZXJFbWFpbCI6InByZXVzZXJAc21hcnRhcHBsaWNhdGlvbnMuY29tIiwiVXNlclJvbGUiOiJQcmVVc2VyIiwiSXNFbWFpbFZlcmlmaWVkIjoiMCIsImlhdCI6MTc1OTg0NTc4MSwiZXhwIjoxNzkxMzgxNzgxfQ.hLGszgoZIR3vyrA2VDYX3O6B8cGCBOb3jsvrmiluGes',
//   'timeoutValue': 20000
// }

// const environment = {
//   'apiUrl':'https://www.smartapplications.com.br/api/',
//   'socketIoUrl' : "http://www.smartapplications.com.br:21020",
//   'preUser' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJWYWxpZGF0ZWQiOiJPSyIsIlVzZXJJRCI6IjMyODZlYWUzLWM2ZTMtNGZjZS1iNjFlLTUwYTBhODk1OGYyOSIsIlVzZXJOYW1lIjoicHJldXNlciIsIlVzZXJFbWFpbCI6InByZXVzZXJAc21hcnRhcHBsaWNhdGlvbnMuY29tIiwiVXNlclJvbGUiOiJQcmVVc2VyIiwiSXNFbWFpbFZlcmlmaWVkIjoiMCIsImlhdCI6MTc1OTg0NTc4MSwiZXhwIjoxNzkxMzgxNzgxfQ.hLGszgoZIR3vyrA2VDYX3O6B8cGCBOb3jsvrmiluGes',
//   'timeoutValue': 20000
// }

export {environment};